<template>
  <div class="replicatedDirectory">
    <MapModal
      :modalNode="modalNode"
      :title="replicatedDirectoryCategory.title"
      :id="replicatedDirectoryCategory.id"
      :close="close"
    >
      <template slot="foot">
        <div class="foot-operate">
          <el-button type="primary" @click="close">
            取消
          </el-button>
          <el-button type="primary" @click="onSubmit">
            保存
          </el-button>
        </div>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import { copyBimPlanGrouping, copyPlanScenes } from "@/api/api";
export default {
  name: "replicatedDirectory",
  components: { MapModal },
  props: ["replicatedDirectoryProps", "close"],
  data() {
    return {
      replicatedDirectoryCategory: {
        title: "选择方案",
        id: "replicatedDirectory", // id和ref使用的同一个
      },
      modalNode: {
        replicatedDirectoryCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 7,
            left: 37,
            unit: "%", // 默认px
          },
          width: "25%", // 宽度配置 默认450px
          height: "500px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "shpTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            expand: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            currentNodeKey: "",
            expandClick: true,
            search: {
              keywords: "text", // 搜素配置关键字 默认是name
            },
            nodeClick: this.nodeClick,
          },
        },
      },
    };
  },
  created() {
    if (this.replicatedDirectoryProps) {
      const { groupingItem, currentKey } = this.replicatedDirectoryProps;
      this.modalNode.replicatedDirectoryCategory.content.treeDataJson = groupingItem;
      this.modalNode.replicatedDirectoryCategory.content.currentNodeKey = Number(
        currentKey
      );
      if (this.replicatedDirectoryProps.type === "scene") {
        this.replicatedDirectoryCategory.title = "选择分组";
        this.modalNode.replicatedDirectoryCategory.content.name = "text";
        this.modalNode.replicatedDirectoryCategory.content.search.keywords =
          "text";
      } else {
        this.modalNode.replicatedDirectoryCategory.content.name = "name";
        this.modalNode.replicatedDirectoryCategory.content.search.keywords =
          "name";
      }
    }
  },
  methods: {
    // 关闭自己
    closeOneSelf() {
      this.$emit("closeReplicatedDirectory");
    },
    nodeClick(e) {
      this.replicatedDirectoryProps.currentKey = e.id;
      if (e.parentId == 0) {
        this.replicatedDirectoryProps.currentKey = null;
      }
    },
    onSubmit() {
      // 复制方案
      if (this.replicatedDirectoryProps.type === "grouping") {
        // 当前方案ID与选中ID不同，则复制分组至其他方案
        if (
          this.replicatedDirectoryProps.currentKey !=
          this.$route.params.scenarioGroupId
        ) {
          copyBimPlanGrouping({
            projectId: window.sessionStorage.getItem("nowProjectId"),
            id: this.replicatedDirectoryProps.currentGroupingId,
            planId: this.replicatedDirectoryProps.currentKey,
          }).then((res) => {
            if (res.data.code == 200 || res.data.code == 204) {
              this.$notify({
                title: "复制分组成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.close();
            } else {
              this.$notify({
                title: "复制分组失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          });
        } else {
          // 相同则复制分组至当前方案
          this.$emit("copyGrouping", {
            id: this.replicatedDirectoryProps.currentGroupingId,
          });
          this.close();
        }
      } else if (this.replicatedDirectoryProps.type === "scene") {
        if (!this.replicatedDirectoryProps.currentKey) {
          return this.$notify({
            title: "请选择分组",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
        }
        if (
          this.replicatedDirectoryProps.currentKey !=
          this.modalNode.replicatedDirectoryCategory.content.currentNodeKey
        ) {
          copyPlanScenes({
            projectId: window.sessionStorage.getItem("nowProjectId"),
            id: this.replicatedDirectoryProps.currentSceneId,
            pId: this.replicatedDirectoryProps.currentKey,
          }).then((res) => {
            let { data, code } = res.data;
            if (code == 200 || code == 204) {
              this.$notify({
                title: "复制成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.$emit("copySuccess");
              this.close();
            } else {
              this.$notify({
                title: "复制失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          });
        } else {
          // 相同则复制分组至当前方案
          this.$emit("copyScene", {
            id: this.replicatedDirectoryProps.currentSceneId,
          });
          this.close();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/box.scss";
.replicatedDirectory {
  @include box_wh(320, 560, true, 386);
  padding: 0;
  overflow-y: auto;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  .el-button.el-button--primary {
    margin: 0px 5px !important;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
</style>
